export const GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_BEGIN = 'GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_BEGIN';
export const GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_SUCCESS = 'GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_SUCCESS';
export const GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_FAILURE = 'GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_FAILURE';
export const GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_DISMISS_ERROR = 'GKPRODUCT_GET_PRODUCT_LIST_ACTIONS_DISMISS_ERROR';
export const GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_BEGIN = 'GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_BEGIN';
export const GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_SUCCESS = 'GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_SUCCESS';
export const GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_FAILURE = 'GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_FAILURE';
export const GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_DISMISS_ERROR = 'GKPRODUCT_PRODUCT_LIST_PARTICULARS_ID_ACTIONS_DISMISS_ERROR';
export const GKPRODUCT_CHOOSE_CURRENT_PRODUCT = 'GKPRODUCT_CHOOSE_CURRENT_PRODUCT';



// WEBPACK FOOTER //
// ./src/features/gkproduct/redux/constants.js